import { http } from './config/config-receituario'

export default {
  findById: (token, id) => {
    return http.get(`vinculo-plano/${id}`, {
      headers: {
        Authorization: token,
      },
    })
  },
  findByName: (token, name) => {
    return http.get('vinculo-plano/filter/' + name, {
      headers: {
        Authorization: token,
      },
    })
  },
  listar: (token) => {
    return http.get('vinculo-plano', {
      headers: {
        Authorization: token,
      },
    })
  },
  salvarVinculo: (token, vinculo) => {
    return http.post('vinculo-plano', vinculo, {
      headers: {
        Authorization: token,
      },
    })
  },
  atualizarVinculo(token, vinculo) {
    return http.put('vinculo-plano/' + vinculo.id_vinculo_plano, vinculo, {
      headers: {
        Authorization: token,
      },
    })
  },
  deleteVinculo: (token, id) => {
    return http.delete('vinculo-plano/' + id, {
      headers: {
        Authorization: token,
      },
    })
  },
}
